import { SubProductAction } from "features/product/types/actions.subproduct";
import React from "react";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { useDispatch } from "services/redux/rootReducer";
import { IconContainer, StyledArrowMenu } from "./header.styled";

interface Props {
    idx: number;
}

const ArrowMenu: React.FC<Props> = ({ idx }) => {
    const dispatch = useDispatch();

    const handleMove = (offset: number) => {
        dispatch({
            type: SubProductAction.MOVE_AND_INSERT_PROPERTY,
            oldIdx: idx,
            newIdx: idx + offset,
        });
    };

    return (
        <StyledArrowMenu>
            <IconContainer onClick={() => handleMove(-1)}>
                <BiChevronLeft />
            </IconContainer>
            <IconContainer onClick={() => handleMove(1)}>
                <BiChevronRight />
            </IconContainer>
        </StyledArrowMenu>
    );
};

export default ArrowMenu;
